var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 111,
    viewBox: "0 0 127 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_883_777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.4678 107.817C90.2332 107.817 111.12 86.9296 111.12 61.1642C111.12 35.3988 90.2332 14.5118 64.4678 14.5118C38.7024 14.5118 17.8154 35.3988 17.8154 61.1642C17.8154 86.9296 38.7024 107.817 64.4678 107.817Z",
    stroke: "#05CB67",
    strokeWidth: 0.747454,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.53 1.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8368 103.795C13.4051 95.3636 7.66306 84.621 5.33674 72.926C3.01041 61.2309 4.20431 49.1086 8.76748 38.0921C13.3306 27.0756 21.0581 17.6596 30.9727 11.0349C40.8873 4.41013 52.5437 0.874207 64.4679 0.874207C76.3921 0.874207 88.0485 4.41013 97.9631 11.0349C107.878 17.6596 115.605 27.0756 120.168 38.0921C124.731 49.1086 125.925 61.2309 123.599 72.926C121.273 84.621 115.531 95.3636 107.099 103.795",
    stroke: "#05CB67",
    strokeWidth: 0.747454,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.53 1.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7166 41.1736C78.1407 41.159 78.5633 41.2299 78.9595 41.3821C79.3556 41.5344 79.717 41.7648 80.0221 42.0597C80.3273 42.3545 80.57 42.7078 80.7357 43.0984C80.9015 43.489 80.9869 43.9091 80.9869 44.3334C80.9869 44.7578 80.9015 45.1778 80.7357 45.5684C80.57 45.9591 80.3273 46.3123 80.0221 46.6072C79.717 46.9021 79.3556 47.1325 78.9595 47.2847C78.5633 47.437 78.1407 47.5079 77.7166 47.4933",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7166 41.1736C78.1407 41.159 78.5633 41.2299 78.9595 41.3821C79.3556 41.5344 79.717 41.7648 80.0221 42.0597C80.3273 42.3545 80.57 42.7078 80.7357 43.0984C80.9015 43.489 80.9869 43.9091 80.9869 44.3334C80.9869 44.7578 80.9015 45.1778 80.7357 45.5684C80.57 45.9591 80.3273 46.3123 80.0221 46.6072C79.717 46.9021 79.3556 47.1325 78.9595 47.2847C78.5633 47.437 78.1407 47.5079 77.7166 47.4933",
    stroke: "#333333",
    strokeWidth: 1.12118,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3614 41.1735C50.5422 41.2016 49.7659 41.5469 49.1963 42.1364C48.6267 42.7259 48.3083 43.5136 48.3083 44.3333C48.3083 45.153 48.6267 45.9407 49.1963 46.5302C49.7659 47.1197 50.5422 47.465 51.3614 47.4932",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3614 41.1735C50.5422 41.2016 49.7659 41.5469 49.1963 42.1364C48.6267 42.7259 48.3083 43.5136 48.3083 44.3333C48.3083 45.153 48.6267 45.9407 49.1963 46.5302C49.7659 47.1197 50.5422 47.465 51.3614 47.4932",
    stroke: "#333333",
    strokeWidth: 1.12118,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6082 36.3412L77.3241 48.6145C77.3241 48.6145 74.4838 60.1402 64.539 60.1402C54.5941 60.1402 51.7538 48.6145 51.7538 48.6145L51.4697 36.3412L58.9443 31.4828L77.6082 36.3412Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.12118,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.301 57.838C53.301 57.838 44.3316 57.838 40.4112 71.3707C37.2121 82.3994 26.6468 88.4351 41.8426 94.9604H87.0635C102.263 88.4351 91.6941 82.3994 88.4949 71.3707C84.5746 57.838 75.605 57.838 75.605 57.838C72.5717 60.7007 68.564 62.3038 64.3932 62.3227C60.2584 62.3009 56.2891 60.696 53.301 57.838Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.12118,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6453 33.7849C63.4739 43.1617 78.7593 40.0373 78.7593 40.0373C78.7593 31.9162 74.4129 25.1891 64.61 25.1891C53.955 25.1891 50.4607 31.9162 50.4607 40.0373C50.4607 40.0373 57.2214 37.0475 58.6453 33.7849Z",
    fill: "#B5BEC6",
    stroke: "#333333",
    strokeWidth: 1.12118,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2083 46.7869C71.0216 46.7869 71.6808 46.1276 71.6808 45.3144C71.6808 44.5012 71.0216 43.8419 70.2083 43.8419C69.3951 43.8419 68.7358 44.5012 68.7358 45.3144C68.7358 46.1276 69.3951 46.7869 70.2083 46.7869Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6414 46.7869C59.4547 46.7869 60.1139 46.1276 60.1139 45.3144C60.1139 44.5012 59.4547 43.8419 58.6414 43.8419C57.8282 43.8419 57.1689 44.5012 57.1689 45.3144C57.1689 46.1276 57.8282 46.7869 58.6414 46.7869Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2395 51.7762C59.2395 51.7762 60.5176 54.6202 64.4978 54.6202H64.3446C68.321 54.6202 69.5992 51.7762 69.5992 51.7762",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2395 51.7762C59.2395 51.7762 60.5176 54.6202 64.4978 54.6202H64.3446C68.321 54.6202 69.5992 51.7762 69.5992 51.7762",
    stroke: "#333333",
    strokeWidth: 1.12118,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4604 45.6582V48.6592",
    stroke: "#333333",
    strokeWidth: 1.12118,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8634 67.88H88.0726C88.8497 67.88 89.5949 68.1887 90.1444 68.7382C90.6939 69.2877 91.0026 70.0329 91.0026 70.81V97.0382C91.0026 97.4347 90.8451 97.8149 90.5648 98.0953C90.2844 98.3756 89.9042 98.5331 89.5077 98.5331H39.4283C39.0318 98.5331 38.6515 98.3756 38.3712 98.0953C38.0908 97.8149 37.9333 97.4347 37.9333 97.0382V70.81C37.9333 70.0329 38.242 69.2877 38.7915 68.7382C39.341 68.1887 40.0863 67.88 40.8634 67.88Z",
    fill: "#EFEFEF",
    stroke: "#333333",
    strokeWidth: 1.12118,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4473 98.4846V100.854C91.4473 101.631 91.1388 102.377 90.5894 102.927C90.04 103.477 89.2947 103.787 88.5173 103.788H40.5644C39.7863 103.788 39.0401 103.479 38.4899 102.928C37.9397 102.378 37.6306 101.632 37.6306 100.854V98.4846H91.4473Z",
    fill: "#EFEFEF",
    stroke: "#333333",
    strokeWidth: 1.12118,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.525 103.683H3.67369C1.95435 103.683 0.560547 105.077 0.560547 106.796V106.8C0.560547 108.519 1.95435 109.913 3.67369 109.913H121.525C123.244 109.913 124.638 108.519 124.638 106.8V106.796C124.638 105.077 123.244 103.683 121.525 103.683Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.12118,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0582 64.4941C33.1191 64.4941 33.9791 63.6341 33.9791 62.5732C33.9791 61.5123 33.1191 60.6522 32.0582 60.6522C30.9972 60.6522 30.1372 61.5123 30.1372 62.5732C30.1372 63.6341 30.9972 64.4941 32.0582 64.4941Z",
    fill: "#05CB67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.761 97.3447C125.822 97.3447 126.682 96.4846 126.682 95.4237C126.682 94.3628 125.822 93.5027 124.761 93.5027C123.7 93.5027 122.84 94.3628 122.84 95.4237C122.84 96.4846 123.7 97.3447 124.761 97.3447Z",
    fill: "#05CB67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.339 45.819C108.982 45.819 111.935 42.8657 111.935 39.2227C111.935 35.5797 108.982 32.6264 105.339 32.6264C101.696 32.6264 98.7424 35.5797 98.7424 39.2227C98.7424 42.8657 101.696 45.819 105.339 45.819Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.12118,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7335 13.7532C40.3765 13.7532 43.3298 10.7999 43.3298 7.15689C43.3298 3.51386 40.3765 0.560608 36.7335 0.560608C33.0905 0.560608 30.1372 3.51386 30.1372 7.15689C30.1372 10.7999 33.0905 13.7532 36.7335 13.7532Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.12118,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7745 95.4238C14.4175 95.4238 17.3708 92.4705 17.3708 88.8275C17.3708 85.1845 14.4175 82.2312 10.7745 82.2312C7.13148 82.2312 4.17822 85.1845 4.17822 88.8275C4.17822 92.4705 7.13148 95.4238 10.7745 95.4238Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.12118,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0026 54.2726C92.79 54.2726 94.2391 52.8236 94.2391 51.0362C94.2391 49.2487 92.79 47.7997 91.0026 47.7997C89.2151 47.7997 87.7661 49.2487 87.7661 51.0362C87.7661 52.8236 89.2151 54.2726 91.0026 54.2726Z",
    stroke: "#05CB67",
    strokeWidth: 1.86864,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39233 14.5118V20.0654",
    stroke: "#05CB67",
    strokeWidth: 1.49491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1691 17.2886H4.61548",
    stroke: "#05CB67",
    strokeWidth: 1.49491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.2922 91.9182C67.8712 91.9182 70.7726 90.7519 70.7726 89.3133C70.7726 87.8747 67.8712 86.7084 64.2922 86.7084C60.7132 86.7084 57.8118 87.8747 57.8118 89.3133C57.8118 90.7519 60.7132 91.9182 64.2922 91.9182Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6621 88.0426C71.0854 88.0426 76.2925 82.8355 76.2925 76.4123C76.2925 69.989 71.0854 64.7819 64.6621 64.7819C58.2388 64.7819 53.0317 69.989 53.0317 76.4123C53.0317 82.8355 58.2388 88.0426 64.6621 88.0426Z",
    fill: "url(#paint0_linear_883_777)",
    stroke: "#333333",
    strokeWidth: 1.12118,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6346 82.8216L57.6101 78.165L59.4787 75.7507L62.9918 78.4677L68.5977 70.6082L71.0792 72.3797L63.6346 82.8216Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_883_777",
    x1: 53.0317,
    y1: 76.4122,
    x2: 76.2925,
    y2: 76.4122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_883_777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126.682,
    height: 110.47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6414b9f8a353b78c4343e281722209f5.svg";
export { ForwardRef as ReactComponent };